module.exports = __webpack_public_path__ + "static/media/political_category.69d0b581.jpg";